import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurchasesComponent } from './purchases.component';
import { PurchaseIndexComponent } from './purchase-index/purchase-index.component';
import {CardModule} from '../../resources/components/card/card.module';
import {PurchasesRoutesModule} from './purchases-routes/purchases-routes.module';
import {TablePurchaseModule} from '../../resources/tables/table-purchase/table-purchase.module';
import { PurchaseViewComponent } from './purchase-view/purchase-view.component';



@NgModule({
  declarations: [
    PurchasesComponent,
    PurchaseIndexComponent,
    PurchaseViewComponent
  ],
    imports: [
        CommonModule,
        CardModule,
        PurchasesRoutesModule,
        TablePurchaseModule
    ]
})
export class PurchasesModule { }
